import { all, takeEvery } from 'redux-saga/effects';
import { VENUES_TYPES } from '../venues/actions';
import { GROUPS_TYPES } from '../groups/actions';
import { USERS_TYPES } from '../users/actions';
import { EVENT_TYPES } from '../events/actions';
import { ZONES_TYPES } from '../zones/actions';
import { PERIODS_TYPES } from '../periods/actions';
import { COMPANIES_TYPES } from '../companies/actions';
import { NOTIFICATION_TYPES } from './actions';
import { defaultError, defaultSuccess, superFunkyUniversalErrorHandler } from '../../libs/utils'
import { EVENT_MATERIALS_TYPES } from '../eventMaterials/actions'
import { ACCESS_VOUCHERS_TYPES } from '../accessVouchers/actions'
import { CATERING_CLAIMS_TYPES } from '../cateringClaims/actions'
import { CATERING_OPTIONS_TYPES } from '../cateringOptions/actions'
import { IGNORE_LIST, shouldIgnore } from '../error-ignore-list'

export function* watchNotificationActions() {
  yield all([
    takeEvery(NOTIFICATION_TYPES.PUSH, action => {
      if(action.payload.type === 'success'){
        defaultSuccess(action.payload.text)
      } else {
        defaultError(action.payload.text)
      }
    })
  ]);

  yield all([
    takeEvery(VENUES_TYPES.UPDATE_SUCCESS, action => {
      defaultSuccess(action.payload.venue.name + ' was updated!');

    })
  ]);

  yield all([
    takeEvery(VENUES_TYPES.CREATE_SUCCESS, action => {
      defaultSuccess(action.payload.venue.name + ' was created!');
    })
  ]);

  yield all([
    takeEvery(VENUES_TYPES.DELETE_SUCCESS, action => {
      defaultSuccess('Venue deleted!');
    })
  ]);

  yield all([
    takeEvery(
      [
        action => action.type?.includes('_FAILURE') && !shouldIgnore(action.type)
        // VENUES_TYPES.CREATE_FAILURE,
        // VENUES_TYPES.UPDATE_FAILURE,
        // VENUES_TYPES.DELETE_FAILURE,
        // GROUPS_TYPES.CREATE_FAILURE,
        // GROUPS_TYPES.UPDATE_FAILURE,
        // GROUPS_TYPES.DELETE_FAILURE,
        // USERS_TYPES.CREATE_FAILURE,
        // USERS_TYPES.UPDATE_FAILURE,
        // EVENT_TYPES.CREATE_FAILURE,
        // EVENT_TYPES.UPDATE_FAILURE,
        // EVENT_TYPES.DELETE_FAILURE,
        // COMPANIES_TYPES.CREATE_FAILURE,
        // COMPANIES_TYPES.UPDATE_FAILURE,
        // COMPANIES_TYPES.DELETE_FAILURE,
        // PERIODS_TYPES.CREATE_FAILURE,
        // PERIODS_TYPES.UPDATE_FAILURE,
        // PERIODS_TYPES.DELETE_FAILURE,
        // ZONES_TYPES.CREATE_FAILURE,
        // ZONES_TYPES.UPDATE_FAILURE,
        // ZONES_TYPES.DELETE_FAILURE,
        // EVENT_MATERIALS_TYPES.CREATE_FAILURE,
        // EVENT_MATERIALS_TYPES.DELETE_FAILURE,
        // EVENT_MATERIALS_TYPES.LOAD_ALL_FAILURE,
        // EVENT_MATERIALS_TYPES.LOAD_FAILURE,
        // EVENT_MATERIALS_TYPES.UPDATE_FAILURE,
        // ACCESS_VOUCHERS_TYPES.CREATE_FAILURE,
        // ACCESS_VOUCHERS_TYPES.LOAD_FAILURE,
        // ACCESS_VOUCHERS_TYPES.LOAD_ALL_FAILURE,
        // ACCESS_VOUCHERS_TYPES.UPDATE_FAILURE,
        // ACCESS_VOUCHERS_TYPES.DELETE_FAILURE,
        // CATERING_CLAIMS_TYPES.CREATE_FAILURE,
        // CATERING_CLAIMS_TYPES.LOAD_FAILURE,
        // CATERING_CLAIMS_TYPES.LOAD_ALL_FAILURE,
        // CATERING_CLAIMS_TYPES.UPDATE_FAILURE,
        // CATERING_CLAIMS_TYPES.DELETE_FAILURE,
        // CATERING_OPTIONS_TYPES.CREATE_FAILURE,
        // CATERING_OPTIONS_TYPES.LOAD_FAILURE,
        // CATERING_OPTIONS_TYPES.LOAD_ALL_FAILURE,
        // CATERING_OPTIONS_TYPES.UPDATE_FAILURE,
        // CATERING_OPTIONS_TYPES.DELETE_FAILURE,
      ],
      (a) => {
        superFunkyUniversalErrorHandler(a.payload)
        // defaultError(`Oops! Something went wrong, please refresh the page and try again. Error message: ${a.payload?.error?.message ?? a.payload?.response?.data?.message}`)
      }
    )
  ]);

  yield all([
    takeEvery(GROUPS_TYPES.UPDATE_SUCCESS, action => {
      defaultSuccess(action.payload.group.name + ' was updated!')
    })
  ]);

  yield all([
    takeEvery(GROUPS_TYPES.CREATE_SUCCESS, action => {
      defaultSuccess(action.payload.group.name + ' was created!')
    })
  ]);

  yield all([
    takeEvery(GROUPS_TYPES.DELETE_SUCCESS, action => {
      defaultSuccess('Group deleted!')
    })
  ]);

  yield all([
    takeEvery(USERS_TYPES.UPDATE_SUCCESS, action => {
      defaultSuccess(`${action.payload.user.firstName} ${action.payload.user.lastName} was updated!`);
    })
  ]);

  yield all([
    takeEvery(USERS_TYPES.CREATE_SUCCESS, action => {
      defaultSuccess(`${action.payload.user.firstName} ${action.payload.user.lastName} was updated!`);
    })
  ]);

  yield all([
    takeEvery(USERS_TYPES.DELETE_SUCCESS, action => {
      defaultSuccess('User deleted!')
    })
  ]);

  yield all([
    takeEvery(EVENT_TYPES.UPDATE_SUCCESS, action => {
      defaultSuccess(action.payload.event.name + ' was updated!')
    })
  ]);

  yield all([
    takeEvery(EVENT_TYPES.CREATE_SUCCESS, action => {
      defaultSuccess(action.payload.event.name + ' was created!')
    })
  ]);

  yield all([
    takeEvery(EVENT_TYPES.DELETE_SUCCESS, action => {
      defaultSuccess('Event deleted!')
    })
  ]);

  yield all([
    takeEvery(ZONES_TYPES.UPDATE_SUCCESS, action => {
      defaultSuccess(action.payload.zone.name + ' was updated!')
    })
  ]);

  yield all([
    takeEvery(ZONES_TYPES.CREATE_SUCCESS, action => {
      defaultSuccess(action.payload.zone.name + ' was created!')
    })
  ]);

  yield all([
    takeEvery(ZONES_TYPES.DELETE_SUCCESS, action => {
      defaultSuccess('Zone deleted!')
    })
  ]);

  yield all([
    takeEvery(COMPANIES_TYPES.UPDATE_SUCCESS, action => {
      defaultSuccess(action.payload.company.name + ' was updated!')
    })
  ]);

  yield all([
    takeEvery(COMPANIES_TYPES.CREATE_SUCCESS, action => {
      defaultSuccess(action.payload.company.name + ' was created!')
    })
  ]);

  yield all([
    takeEvery(COMPANIES_TYPES.DELETE_SUCCESS, action => {
      defaultSuccess('Company deleted!')
    })
  ]);

  yield all([
    takeEvery(PERIODS_TYPES.UPDATE_SUCCESS, action => {
      defaultSuccess(action.payload.period.name + ' was updated!')
    })
  ]);

  yield all([
    takeEvery(PERIODS_TYPES.CREATE_SUCCESS, action => {
      defaultSuccess(action.payload.period.name + ' was created!')
    })
  ]);

  yield all([
    takeEvery(PERIODS_TYPES.DELETE_SUCCESS, action => {
      defaultSuccess('Period deleted!')
    })
  ]);
}
